import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    value: string;
    label: string;
  }[];
  placeholder?: string;
}
const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  className,
  label,
  error,
  options,
  placeholder,
  ...props
}, ref) => {
  return <div className="w-full space-y-2" data-id="element-279">
        {label && <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-slate-700" data-id="element-280">
            {label}
          </label>}
        <div className="relative" data-id="element-281">
          <select className={cn('flex h-10 w-full items-center justify-between rounded-md border border-slate-300 bg-white px-3 py-2 text-sm ring-offset-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-[#218080] focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 appearance-none', error && 'border-red-500 focus:ring-red-500', className)} ref={ref} {...props} data-id="element-282">
            {placeholder && <option value="" disabled selected data-id="element-283">
                {placeholder}
              </option>}
            {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-284">
                {opt.label}
              </option>)}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-slate-500" data-id="element-285">
            <svg className="h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" data-id="element-286">
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" data-id="element-287" />
            </svg>
          </div>
        </div>
        {error && <p className="text-xs font-medium text-red-500" data-id="element-288">{error}</p>}
      </div>;
});
Select.displayName = 'Select';
export { Select };